import { JSX } from "react";

interface CategoryProductsSkeletonProps {
    gridLayout: boolean;
}

export const CategoryProductsSkeleton = (
    props: CategoryProductsSkeletonProps,
): JSX.Element => {
    const { gridLayout } = props;
    const itemCount = gridLayout ? 6 : 4;

    return (
        <div
            className={
                "c-products-list__sub-item__items c-products-list__sub-item__items--loading " +
                (gridLayout ? "c-products-list__sub-item__items--grid" : "")
            }
            aria-busy="true"
            aria-live="polite"
        >
            {Array(itemCount)
                .fill(0)
                .map((_, index) => (
                    <div
                        key={index}
                        className={
                            "c-products-list__sub-item__skeleton " +
                            (gridLayout
                                ? "c-products-list__sub-item__skeleton--grid"
                                : "c-products-list__sub-item__skeleton--list")
                        }
                    >
                        {gridLayout && (
                            <span className="skeleton c-products-list__sub-item__skeleton-image" />
                        )}
                        <span className="skeleton c-products-list__sub-item__skeleton-title" />
                        {gridLayout && (
                            <span className="skeleton c-products-list__sub-item__skeleton-price" />
                        )}
                    </div>
                ))}
        </div>
    );
};
